import styled from "styled-components";
import { Col, Row } from "antd";
import { WrapGlobeMobile } from "@/components/customs/Map/mapGlobeWrapper";
import { RATypography, RAImage } from "@/components/customs";
import { useState } from "react";
import { AIRCRAFT_RANGE_STEP } from "../index";
import { IconAircraftRange, IconSwipe, IconAircraftFillSvg } from "@/assets/images";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination } from "swiper";

export function AircraftRangeMobile({ centerAiport, range = 0, routes = [], description = "" }) {
	const [selectedRoute, setSelectedRoute] = useState(null);

	return (
		<Container>
			<Row justify="center">
				<Padding span={24} style={{ paddingTop: 0 }}>
					<Row>
						<WrapperContent>
							<RATypography variant="h3">Aircraft Range</RATypography>
						</WrapperContent>
					</Row>
					<Row style={{ paddingTop: 12 }}>
						<RATypography
							variant="body3"
							color="#595959"
							style={{
								maxHeight: 200,
								textOverflow: "ellipsis",
								display: "-webkit-box",
								overflow: "hidden",
								WebkitLineClamp: "5",
								WebkitBoxOrient: "vertical",
							}}
						>
							{description}
						</RATypography>
					</Row>
				</Padding>
			</Row>
			<div
				id="snap-disabled"
				style={{
					flexGrow: 1,
					display: "flex",
					flexDirection: "column",
					overflow: "hidden",
				}}
			>
				<WrapperGlobe>
					<WrapGlobeMobile
						centerAiport={centerAiport}
						range={range}
						routes={routes}
						selectedRoute={selectedRoute}
					/>
				</WrapperGlobe>
				<Padding>
					<Swiper
						pagination={true}
						modules={[Pagination]}
						spaceBetween={20}
						loop={true}
						onActiveIndexChange={(e) => {
							if (routes?.length > 0 && e.realIndex - 1 >= 0 && routes[e.realIndex - 1]) {
								const { from_airport, to_airport } = routes[e.realIndex - 1];

								setSelectedRoute({
									start: from_airport,
									end: to_airport,
									_id: e.realIndex - 1,
								});
							} else {
								setSelectedRoute(null);
							}
						}}
					>
						<SwiperSlide>
							<div style={{ paddingBottom: 36 }}>
								<CardContainer align="middle">
									<Col
										span={16}
										style={{
											padding: "16px 24px",
										}}
									>
										<Row align="middle" gutter={8}>
											<Col>
												<RAImage
													width="20px"
													height="20px"
													sizes="20px"
													url={IconAircraftRange}
												/>
											</Col>
											<Col>
												<RATypography variant="body3" color="#595959">
													Aircraft Range
												</RATypography>
											</Col>
										</Row>
										<Row align="bottom" gutter={8}>
											<Col>
												<RATypography variant="sub-heading1">{range}</RATypography>
											</Col>
											<Col>
												<RATypography variant="sub-heading3">NM</RATypography>
											</Col>
										</Row>
									</Col>
									<Col
										span={8}
										style={{
											borderLeft: "1px dashed #e9e8e8",
											padding: "8px 24px",
										}}
									>
										<Row align="middle">
											<Col span={24}>
												<Row>
													<RAImage width="20px" height="20px" sizes="20px" url={IconSwipe} />
												</Row>
												<Row>
													<RATypography variant="body4">Swipe for routes</RATypography>
												</Row>
											</Col>
										</Row>
									</Col>
								</CardContainer>
							</div>
						</SwiperSlide>
						{routes?.map((route, index) => {
							const { from_airport, to_airport, fly_hours, fly_minutes, distance } = route;
							const getHours = () => {
								let value = Number.parseFloat(fly_hours + fly_minutes / 60).toFixed(1);
								return value;
							};
							return (
								<SwiperSlide key={index}>
									<div style={{ paddingBottom: 36 }}>
										<CardContainer
											align="middle"
											style={{ padding: "8px 24px" }}
											onClick={() =>
												setSelectedRoute({
													start: from_airport,
													end: to_airport,
													_id: index,
												})
											}
										>
											<Col span={24}>
												<Row align="middle">
													<Col span={9}>
														<Row align="middle" justify="center">
															<RATypography variant="sub-heading3">
																{from_airport?.location?.city || ""}
															</RATypography>
														</Row>
													</Col>
													<Col
														span={6}
														style={{
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
														}}
													>
														<AircraftLine />
														<RAImage
															url={IconAircraftFillSvg}
															width={40}
															height={40}
															sizes="40px"
														/>
													</Col>
													<Col span={9}>
														<Row align="middle" justify="center">
															<RATypography variant="sub-heading3" align="right">
																{to_airport?.location?.city || ""}
															</RATypography>
														</Row>
													</Col>
												</Row>

												<Row align="middle" justify="center">
													<RangeCol>
														<Row align="middle" justify="center">
															<RangeText>
																{`${getHours()} ${
																	getHours() > 1 ? "hours" : "hour"
																} - ${distance} miles`}
															</RangeText>
														</Row>
													</RangeCol>
												</Row>
											</Col>
										</CardContainer>
									</div>
								</SwiperSlide>
							);
						})}
					</Swiper>
				</Padding>
			</div>
		</Container>
	);
}

const WrapperGlobe = styled.div`
	flex-grow: 1;
	overflow: hidden;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	@media (orientation: landscape) {
		max-height: 100vw;
	}

	@media (orientation: portrait) {
		max-height: 50vh;
	}
`;

const Padding = styled.div`
	padding: 20px 136px;
	max-width: 1442px;
	width: 100%;
	@media (max-width: 991px) {
		padding: 20px 80px;
	}
	@media (max-width: 767px) {
		padding: 20px 32px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
`;
const WrapperContent = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	/* height: 100vh; */
	scroll-snap-align: start;
	.swiper-pagination-bullet-active {
		background-color: #ffb11a;
	}
	@media (max-width: 991px) {
		padding: 90px 0px;
	}
	@media (max-width: 767px) {
		padding: 60px 0px;
	}
	@media (max-width: 575px) {
		padding: 40px 0px;
	}
`;

const CardContainer = styled(Row)`
	border-radius: 16px;
	border: 1px solid #e9e8e8;
`;
const AircraftLine = styled.div`
	position: absolute;
	width: 100%;
	height: 1px;
	left: 0;
	top: 20px;
	border: 1px dashed #e9e8e8;
`;

const RangeCol = styled(Col)`
	padding: 6px 20px;
	max-width: 180px;
	background: #f9f9f9;
	border-radius: 30px;
`;

const RangeText = styled.span`
	font-family: "DM Sans";
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	text-align: center;
	color: #595959;
`;
